export default "__VITE_ASSET__D0r1Z2sQ__"